<p-table [showGridlines]="true" #membershipDuesAgingGrid styleClass="wl-responsive-prime-datatable wl-dashboard-dues-aging" [value]="agingSummary" [paginator]="false">
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="text-align: left !important">
        <span>{{ 'dashboard.revenue.dues-aging' | translate | titlecase }}</span>
      </th>
      <th>
        <span>{{ 'dashboard.revenue.outstanding' | translate | titlecase }}</span>
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template let-category pTemplate="body">
    <tr>
      <td style="text-align: left !important">
        <span>{{ category?.Title }}</span>
      </td>
      <td>
        <span>{{ category?.AmountDue | currency }}</span>
      </td>
      <td>
        <span>{{ category?.PercentageDue | atlasPercent: true }}</span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr class="footer">
      <td style="text-align: left !important">
        <span>{{ 'dashboard.revenue.dues-total' | translate | titlecase }}</span>
      </td>
      <td>
        <span>{{ agingTotals?.AmountDue | currency }}</span>
      </td>
      <td></td>
    </tr>
  </ng-template>
</p-table>
